// removed by extract-text-webpack-plugin
module.exports = {"TripletItem":"TripletItem-TripletItem--C8Vr4","status-ok":"TripletItem-status-ok--21vrK","status-warning":"TripletItem-status-warning--3eVMg","status-problem":"TripletItem-status-problem--bmTKy","status-disconnected":"TripletItem-status-disconnected--3Qkcp","containsDevice":"TripletItem-containsDevice--16X1N","context":"TripletItem-context--23cHo","content":"TripletItem-content--oyh7h","smallerText":"TripletItem-smallerText--2Vqsb"};


//////////////////
// WEBPACK FOOTER
// ./src/components/DataPanel/TripletItem/TripletItem.scss
// module id = G3SD
// module chunks = 4